import { acceptHMRUpdate, defineStore } from 'pinia'

import { type Role } from '~/types.ts'

export const APP_ROLES = new Set(['Owner', 'Admin', 'Billing manager', 'Team manager', 'Auditor', 'Developer', 'Transaction monitoring'])
export const APP_MODULE_ROLES = new Set(['Transaction monitoring'])

export function isAppRole(role: string): boolean {
  return APP_ROLES.has(role)
}

export function isAppModuleRole(role: string): boolean {
  return APP_MODULE_ROLES.has(role)
}

export const useRoles = defineStore('roles', () => {
  const roles = ref<Record<number, Role>>({})

  const appRoles = computed((): Role[] => Object.values(roles.value).filter((role) => APP_ROLES.has(role.name)))
  const administrationRoles = computed((): Role[] => Object.values(roles.value).filter((role) => !APP_ROLES.has(role.name)))

  api.get('roles').then(({ data }) => (roles.value = keyBy('id', data)))

  return { roles, appRoles, administrationRoles }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRoles, import.meta.hot))
}
